import { z } from 'zod';

import { DiaSemanaEnum, HorarioDoDia } from './enums';
import type { DiaSemana, HorarioDoDiaType } from './enums';

export type HorarioOutput = {
  id: string;
  matriculaId: string;
  diaSemana: DiaSemana;
  horario: HorarioDoDiaType;
  desativadoEm: Date | null;
};

export const HorarioCreateInput = z.object({
  diaSemana: DiaSemanaEnum,
  horario: HorarioDoDia,
});

export type HorarioOutputType = HorarioOutput;
export type HorarioCreateInputType = z.infer<typeof HorarioCreateInput>;
